/*
  vivi sale engine (countdowns, date-switched copy, sticky bar)
  - All dates are entered as Eastern Time wall-clock strings: "YYYY-MM-DD HH:MM[:SS]"
  - Conversion to a real instant happens in the browser via Intl (America/New_York),
    so DST is handled and cached pages never serve stale server-side dates.
  - One fixed end time for everyone. No per-visitor timers, no resets, no loops.
  - QA only: add ?vivi_now=2026-11-27%2010:00 to the URL to preview a moment in ET.
*/
(function () {
  if (window.ViviSale) return;

  var TZ = 'America/New_York';
  var RE = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{1,2}):(\d{2})(?::(\d{2}))?$/;

  function tzOffset(t) {
    try {
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone: TZ, hourCycle: 'h23', year: 'numeric', month: '2-digit',
        day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'
      }).formatToParts(new Date(t));
      var o = {};
      parts.forEach(function (p) { o[p.type] = p.value; });
      return Date.UTC(+o.year, +o.month - 1, +o.day, +o.hour % 24, +o.minute, +o.second) - t;
    } catch (e) {
      return -5 * 3600 * 1000; /* fallback: EST (all BFCM 2026 dates are after Nov 1 DST change) */
    }
  }

  /* "2026-11-12 23:59:59" (ET) -> epoch ms */
  function etToMs(str) {
    var m = String(str || '').trim().match(RE);
    if (!m) return NaN;
    var wall = Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], +(m[6] || 0));
    var t = wall - tzOffset(wall);
    return wall - tzOffset(t);
  }

  var previewNow = NaN;
  try {
    var q = new URLSearchParams(window.location.search).get('vivi_now');
    if (q) previewNow = etToMs(q.replace('T', ' '));
  } catch (e) {}
  var previewStart = Date.now();

  function now() {
    return isNaN(previewNow) ? Date.now() : previewNow + (Date.now() - previewStart);
  }

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function parts(ms) {
    var s = Math.max(0, Math.floor(ms / 1000));
    return { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
  }

  /* Elements with data-vivi-from / data-vivi-until (ET strings) only show inside that window */
  function applyWindows(root, t) {
    root.querySelectorAll('[data-vivi-from],[data-vivi-until]').forEach(function (el) {
      var from = etToMs(el.getAttribute('data-vivi-from'));
      var until = etToMs(el.getAttribute('data-vivi-until'));
      var on = (isNaN(from) || t >= from) && (isNaN(until) || t < until);
      el._viviWin = on;
      el.hidden = !on;
    });
  }

  function renderTimer(el, t) {
    var end = etToMs(el.getAttribute('data-vivi-end'));
    if (isNaN(end)) return true;
    var left = end - t;
    var expired = left <= 0;
    var p = parts(left);
    el.querySelectorAll('[data-vivi-unit]').forEach(function (u) {
      var k = u.getAttribute('data-vivi-unit');
      u.textContent = k === 'd' ? p.d : pad(p[k]);
    });
    var compact = el.querySelector('[data-vivi-compact]');
    if (compact) {
      compact.textContent = (p.d > 0 ? p.d + 'd ' : '') + pad(p.h) + 'h ' + pad(p.m) + 'm ' + pad(p.s) + 's';
    }
    el.classList.toggle('is-expired', expired);
    el.querySelectorAll('[data-vivi-live]').forEach(function (x) { x.hidden = expired || x._viviWin === false; });
    el.querySelectorAll('[data-vivi-expired]').forEach(function (x) { x.hidden = !expired; });
    if (expired && !el._viviDone) {
      el._viviDone = true;
      var to = el.getAttribute('data-vivi-expired-redirect');
      if (to && isNaN(previewNow) && to !== window.location.pathname) {
        window.location.replace(to);
      }
    }
    return expired;
  }

  function tick() {
    var t = now();
    applyWindows(document, t);
    document.querySelectorAll('[data-vivi-end]').forEach(function (el) { renderTimer(el, t); });
  }

  /* Sticky bar: dismiss for this browser session + offset under a sticky theme header */
  function initBars() {
    document.querySelectorAll('[data-vivi-bar]').forEach(function (bar) {
      if (bar._viviInit) return;
      bar._viviInit = true;
      var key = 'vivi-bar-dismissed:' + (bar.getAttribute('data-vivi-bar') || '');
      try { if (sessionStorage.getItem(key) === '1') { bar.hidden = true; return; } } catch (e) {}
      var btn = bar.querySelector('[data-vivi-bar-close]');
      if (btn) btn.addEventListener('click', function () {
        bar.hidden = true;
        try { sessionStorage.setItem(key, '1'); } catch (e) {}
      });
      bar.querySelectorAll('a[href^="#"]').forEach(function (a) {
        a.addEventListener('click', function (ev) {
          var sel = a.getAttribute('href');
          var target = null;
          try { target = document.querySelector(sel); } catch (e) {}
          if (!target) target = document.querySelector('.vivi-sps, product-info, form[action*="/cart/add"]');
          if (target) {
            ev.preventDefault();
            var y = target.getBoundingClientRect().top + window.pageYOffset - (bar.offsetHeight + headerOffset()) - 8;
            window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
          }
        });
      });
      var host = bar.closest('.shopify-section') || bar;
      /* Sit above the theme header. Sleek's transparent header is position:absolute over the
         first content section, so a bar left inside <main> would be covered by it. */
      var firstHeader = document.querySelector('.shopify-section-group-header-group');
      if (firstHeader && host.parentNode && !host.contains(firstHeader)) {
        firstHeader.parentNode.insertBefore(host, firstHeader);
      }
      function place() { host.style.top = headerOffset() + 'px'; }
      place();
      window.addEventListener('scroll', place, { passive: true });
      window.addEventListener('resize', place);
    });
  }

  function headerOffset() {
    var h = document.querySelector('.header-section, .shopify-section-group-header-group');
    if (!h) return 0;
    var cs = window.getComputedStyle(h);
    var inner = h.querySelector('header');
    var ics = inner ? window.getComputedStyle(inner) : null;
    var stuck = /sticky|fixed/.test(cs.position) || (ics && /sticky|fixed/.test(ics.position));
    if (!stuck) return 0;
    var r = (inner || h).getBoundingClientRect();
    return Math.max(0, Math.round(r.bottom));
  }

  window.ViviSale = { etToMs: etToMs, now: now, tick: tick };

  function start() {
    initBars();
    tick();
    setInterval(tick, 1000);
    document.addEventListener('shopify:section:load', function () { initBars(); tick(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
